<template>
  <div id="main" class="seatMap">
    <div class="sizeBox">
      <el-slider vertical height="200px" v-model="value1" :max="30" :min="11" @change="changeDomSize2"></el-slider>
      <i class="el-icon-circle-plus-outline amplification" @click="changeDomSize('add')" title="放大"></i>
      <i class="el-icon-remove-outline narrow" @click="changeDomSize('jian')" title="缩小"></i>
    </div>
    <div class="menu">
      <el-button type="text" @click="seeVisible = true" size="small">查看空置情况</el-button>
      A区
      <i class="tips abgc"></i>
      B区
      <i class="tips bbgc"></i>
      C区
      <i class="tips cbgc"></i>
      Z区
      <i class="tips zbgc"></i>
      <el-input style="width:180px;margin:5px 0 0 5px" size="small" v-model="searchName" @clear="clearName"
        placeholder="请输入名字" clearable>
        <el-button slot="append" icon="el-icon-search" @click="toName"></el-button>
      </el-input>
    </div>
    <div id="content">
      <col-sctz39 :seatData="seatData" :checkList="checkList" />
    </div>
    <see-dialog :visible="seeVisible" :propData="seeData" @close="updateSeeVisible" @updateCheck="updateCheck" />
  </div>
</template>

<script>
import seeDialog from './components/seeDialog'
import colSctz39 from './components/col-sctz39'
import { companySeat } from '@/api/seat.js'

export default {
  components: {
    'see-dialog': seeDialog,
    'col-sctz39': colSctz39
  },
  props: {
    activeName: {
      type: String,
      default() {
        return ''
      }
    }
  },
  watch: {
    activeName(val) {
      if (val === 'sctz39') {
        document.documentElement.style.fontSize = this.value1 + 'px'
      }
    },
    immediate: true
  },
  data() {
    return {
      value1: 11,
      seeVisible: false,
      checkList: ['A', 'B', 'C', 'Z'],
      searchName: '',
      havaClass: [],
      seeData: {
        city: 4,
        countA: 0,
        countB: 0,
        countC: 0,
        countZ: 0,
        countAall: 0,
        countBall: 0,
        countCall: 0,
        countZall: 0,
        countAll: 0,
        all: 0,
        allKong: 0
      },
      propData: [],
      seatData: {
        A1: [
          { seat: 'A-01-01' }, { seat: 'A-01-02' }, { seat: 'A-01-03' }, { seat: 'A-01-04' },
          { seat: 'A-01-05' }, { seat: 'A-01-10' }, { seat: 'A-01-09' }, { seat: 'A-01-08' },
          { seat: 'A-01-07' }, { seat: 'A-01-06' }
        ],
        A2: [
          { seat: 'A-02-01' }, { seat: 'A-02-02' }, { seat: 'A-02-03' }, { seat: 'A-02-04' },
          { seat: 'A-02-05' }, { seat: 'A-02-10' }, { seat: 'A-02-09' }, { seat: 'A-02-08' },
          { seat: 'A-02-07' }, { seat: 'A-02-06' }
        ],
        A3: [
          { seat: 'A-03-01' }, { seat: 'A-03-02' }, { seat: 'A-03-03' }, { seat: 'A-03-04' },
          { seat: 'A-03-05' }, { seat: 'A-03-10' }, { seat: 'A-03-09' }, { seat: 'A-03-08' },
          { seat: 'A-03-07' }, { seat: 'A-03-06' }
        ],
        A4_1: [
          { seat: 'A-04-01' }, { seat: 'A-04-02' }, { seat: 'A-04-03' }, { seat: 'A-04-04' }
        ],
        A4_2: [
          { seat: 'A-04-10' }, { seat: 'A-04-09' }, { seat: 'A-04-08' }, { seat: 'A-04-07' },
          { seat: 'A-04-06' }, { seat: 'A-04-05' }
        ],
        A5: [
          { seat: 'A-05-01' }, { seat: 'A-05-02' }, { seat: 'A-05-03' }, { seat: 'A-05-04' },
          { seat: 'A-05-05' }, { seat: 'A-05-06' }, { seat: 'A-05-12' }, { seat: 'A-05-11' },
          { seat: 'A-05-10' }, { seat: 'A-05-09' }, { seat: 'A-05-08' }, { seat: 'A-05-07' }
        ],
        A6: [
          { seat: 'A-06-01' }, { seat: 'A-06-02' }, { seat: 'A-06-03' }, { seat: 'A-06-04' },
          { seat: 'A-06-05' }, { seat: 'A-06-06' }, { seat: 'A-06-12' }, { seat: 'A-06-11' },
          { seat: 'A-06-10' }, { seat: 'A-06-09' }, { seat: 'A-06-08' }, { seat: 'A-06-07' }
        ],
        A7: [
          { seat: 'A-07-01' }, { seat: 'A-07-02' }, { seat: 'A-07-03' }, { seat: 'A-07-04' },
          { seat: 'A-07-05' }, { seat: 'A-07-06' }, { seat: 'A-07-12' }, { seat: 'A-07-11' },
          { seat: 'A-07-10' }, { seat: 'A-07-09' }, { seat: 'A-07-08' }, { seat: 'A-07-07' }
        ],
        A8: [
          { seat: 'A-08-01' }, { seat: 'A-08-02' }, { seat: 'A-08-03' }, { seat: 'A-08-04' },
          { seat: 'A-08-05' }, { seat: 'A-08-06' }, { seat: 'A-08-12' }, { seat: 'A-08-11' },
          { seat: 'A-08-10' }, { seat: 'A-08-09' }, { seat: 'A-08-08' }, { seat: 'A-08-07' }
        ],
        A9: [
          { seat: 'A-09-01' }, { seat: 'A-09-02' }, { seat: 'A-09-03' }, { seat: 'A-09-04' },
          { seat: 'A-09-05' }, { seat: 'A-09-06' }, { seat: 'A-09-12' }, { seat: 'A-09-11' },
          { seat: 'A-09-10' }, { seat: 'A-09-09' }, { seat: 'A-09-08' }, { seat: 'A-09-07' }
        ],
        A10: [
          { seat: 'A-10-01' }, { seat: 'A-10-02' }, { seat: 'A-10-03' }, { seat: 'A-10-04' },
          { seat: 'A-10-05' }, { seat: 'A-10-06' }, { seat: 'A-10-12' }, { seat: 'A-10-11' },
          { seat: 'A-10-10' }, { seat: 'A-10-09' }, { seat: 'A-10-08' }, { seat: 'A-10-07' }
        ],
        A11: [
          { seat: 'A-11-01' }, { seat: 'A-11-02' }, { seat: 'A-11-03' }, { seat: 'A-11-04' },
          { seat: 'A-11-05' }, { seat: 'A-11-06' }, { seat: 'A-11-12' }, { seat: 'A-11-11' },
          { seat: 'A-11-10' }, { seat: 'A-11-09' }, { seat: 'A-11-08' }, { seat: 'A-11-07' }
        ],
        B1: [
          { seat: 'B-01-01' }, { seat: 'B-01-02' }, { seat: 'B-01-03' }, { seat: 'B-01-04' },
          { seat: 'B-01-05' }, { seat: 'B-01-06' }, { seat: 'B-01-07' }, { seat: 'B-01-08' }
        ],
        B2: [
          { seat: 'B-02-01' }, { seat: 'B-02-02' }, { seat: 'B-02-03' }, { seat: 'B-02-04' },
          { seat: 'B-02-05' }, { seat: 'B-02-06' }, { seat: 'B-02-07' }, { seat: 'B-02-14' },
          { seat: 'B-02-13' }, { seat: 'B-02-12' }, { seat: 'B-02-11' }, { seat: 'B-02-10' },
          { seat: 'B-02-09' }, { seat: 'B-02-08' }
        ],
        B3: [
          { seat: 'B-03-01' }, { seat: 'B-03-02' }, { seat: 'B-03-03' }, { seat: 'B-03-04' },
          { seat: 'B-03-05' }, { seat: 'B-03-06' }, { seat: 'B-03-07' }, { seat: 'B-03-14' },
          { seat: 'B-03-13' }, { seat: 'B-03-12' }, { seat: 'B-03-11' }, { seat: 'B-03-10' },
          { seat: 'B-03-09' }, { seat: 'B-03-08' }
        ],
        B4: [
          { seat: 'B-04-01' }, { seat: 'B-04-02' }, { seat: 'B-04-03' }, { seat: 'B-04-04' },
          { seat: 'B-04-05' }, { seat: 'B-04-06' }, { seat: 'B-04-12' }, { seat: 'B-04-11' },
          { seat: 'B-04-10' }, { seat: 'B-04-09' }, { seat: 'B-04-08' }, { seat: 'B-04-07' }
        ],
        B5: [
          { seat: 'B-05-01' }, { seat: 'B-05-02' }, { seat: 'B-05-03' }, { seat: 'B-05-04' },
          { seat: 'B-05-05' }, { seat: 'B-05-10' }, { seat: 'B-05-09' }, { seat: 'B-05-08' },
          { seat: 'B-05-07' }, { seat: 'B-05-06' }
        ],
        B6: [
          { seat: 'B-06-01' }, { seat: 'B-06-02' }, { seat: 'B-06-03' }, { seat: 'B-06-04' },
          { seat: 'B-06-05' }, { seat: 'B-06-10' }, { seat: 'B-06-09' }, { seat: 'B-06-08' },
          { seat: 'B-06-07' }, { seat: 'B-06-06' }
        ],
        B7: [
          { seat: 'B-07-01' }, { seat: 'B-07-02' }, { seat: 'B-07-03' }, { seat: 'B-07-04' },
          { seat: 'B-07-08' }, { seat: 'B-07-07' }, { seat: 'B-07-06' }, { seat: 'B-07-05' }
        ],
        B8: [
          { seat: 'B-08-01' }, { seat: 'B-08-02' }, { seat: 'B-08-03' }, { seat: 'B-08-04' },
          { seat: 'B-08-08' }, { seat: 'B-08-07' }, { seat: 'B-08-06' }, { seat: 'B-08-05' }
        ],
        B9: [
          { seat: 'B-09-01' }, { seat: 'B-09-02' }, { seat: 'B-09-03' },
          { seat: 'B-09-06' }, { seat: 'B-09-05' }, { seat: 'B-09-04' }
        ],
        B10: [
          { seat: 'B-10-01' }, { seat: 'B-10-02' }, { seat: 'B-10-03' }, { seat: 'B-10-04' },
          { seat: 'B-10-08' }, { seat: 'B-10-07' }, { seat: 'B-10-06' }, { seat: 'B-10-05' }
        ],
        B11: [
          { seat: 'B-11-01' }, { seat: 'B-11-02' }, { seat: 'B-11-03' }, { seat: 'B-11-04' },
          { seat: 'B-11-08' }, { seat: 'B-11-07' }, { seat: 'B-11-06' }, { seat: 'B-11-05' }
        ],
        C1: [
          { seat: 'C-01-09' }, { seat: 'notUsed-C1-1' }, { seat: 'notUsed-C1-2' }, { seat: 'C-01-08' }, { seat: 'C-01-07' }, { seat: 'notUsed-C1-3' }, { seat: 'notUsed-C1-4' }, { seat: 'C-01-06' },
          { seat: 'C-01-05' }, { seat: 'notUsed-C1-5' }, { seat: 'notUsed-C1-6' }, { seat: 'C-01-04' }, { seat: 'C-01-03' }, { seat: 'notUsed-C1-7' }, { seat: 'notUsed-C1-8' }, { seat: 'C-01-02' },
          { seat: 'C-01-01' }, { seat: 'notUsed-C1-9' }
        ],
        C2: [
          { seat: 'notUsed-C2-1' }, { seat: 'C-02-09' }, { seat: 'C-02-08' }, { seat: 'notUsed-C2-2' }, { seat: 'notUsed-C2-3' }, { seat: 'C-02-07' }, { seat: 'C-02-06' }, { seat: 'notUsed-C2-4' }, { seat: 'notUsed-C2-5' },
          { seat: 'C-02-05' }, { seat: 'C-02-04' }, { seat: 'notUsed-C2-6' }, { seat: 'notUsed-C2-7' }, { seat: 'C-02-03' }, { seat: 'C-02-02' }, { seat: 'notUsed-C2-8' }, { seat: 'notUsed-C2-9' },
          { seat: 'C-02-01' }
        ],
        // 添加Z区座位
        Z1: [
          { seat: 'Z-01-01' }, { seat: 'Z-01-02' }, { seat: 'Z-01-03' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      companySeat({ city: 4 }).then(res => {
        const data = [...res.data]
        const seatData = JSON.parse(JSON.stringify(this.seatData))
        this.seeData.all = 0
        this.seeData.allKong = 0
        this.seeData.countA = 0
        this.seeData.countB = 0
        this.seeData.countC = 0
        this.seeData.countZ = 0
        this.seeData.countAall = 0
        this.seeData.countBall = 0
        this.seeData.countCall = 0
        this.seeData.countZall = 0

        Object.keys(seatData).map(key => {
          seatData[key].forEach((obj, index) => {
            if (obj.seat.startsWith('A-')) {
              this.seeData.countAall += 1
            } else if (obj.seat.startsWith('B-')) {
              this.seeData.countBall += 1
            } else if (obj.seat.startsWith('C-')) {
              this.seeData.countCall += 1
            } else if (obj.seat.startsWith('Z-')) {
              this.seeData.countZall += 1
            }

            const newObj = data.find(ele => obj.seat === ele.seat)
            if (newObj) {
              seatData[key][index] = newObj
              if (newObj.seat.startsWith('A-') && newObj.isUnused === '0') {
                this.seeData.countA += 1
              } else if (newObj.seat.startsWith('B-') && newObj.isUnused === '0') {
                this.seeData.countB += 1
              } else if (newObj.seat.startsWith('C-') && newObj.isUnused === '0') {
                this.seeData.countC += 1
              } else if (newObj.seat.startsWith('Z-') && newObj.isUnused === '0') {
                this.seeData.countZ += 1
              }
            }
          })
        })
        this.seeData.all = this.seeData.countAall + this.seeData.countBall + this.seeData.countCall + this.seeData.countZall
        this.seeData.allKong = this.seeData.countA + this.seeData.countB + this.seeData.countC + this.seeData.countZ
        this.seatData = seatData
      })
    },
    changeDomSize(type) {
      if (type === 'add' && this.value1 < 30) {
        const size = this.value1 += 1
        document.documentElement.style.fontSize = size + 'px'
      } else if (type === 'jian' && this.value1 > 11) {
        const size = this.value1 -= 1
        document.documentElement.style.fontSize = size + 'px'
      }
    },
    changeDomSize2(val) {
      this.value1 = val
      document.documentElement.style.fontSize = val + 'px'
    },
    updateSeeVisible(val) {
      this.seeVisible = val
    },
    updateCheck(val) {
      this.checkList = val
    },
    toName() {
      if (this.searchName) {
        const id = '#' + this.searchName
        const className = '.' + this.searchName
        const returnEle = document.querySelector(id)
        if (returnEle) {
          const arr = [...this.havaClass]
          for (const i in arr) {
            if (arr[i] !== className) {
              const otherDom = document.querySelectorAll(arr[i])
              for (let t = 0; t < otherDom.length; t++) {
                const otel = otherDom[t]
                otel.classList.remove('searchClass')
              }
            }
          }
          returnEle.scrollIntoView(true)
        }
        var allClassDom = document.querySelectorAll(className)
        for (let j = 0; j < allClassDom.length; j++) {
          const el = allClassDom[j]
          el.classList.add('searchClass')
        }
        this.havaClass = [className]
      } else {
        this.clearName()
      }
    },
    clearName() {
      const arr = [...this.havaClass]
      for (const i in arr) {
        const otherDom = document.querySelectorAll(arr[i])
        for (let t = 0; t < otherDom.length; t++) {
          const otel = otherDom[t]
          otel.classList.remove('searchClass')
        }
      }
      this.havaClass = []
    }
  }
}
</script>

<style lang="scss" scoped>
#content {
  padding: 1rem 1rem 1rem 0;
  width: 169rem;
  margin-left: 30px;
  overflow: hidden;
}

.seatMap {
  overflow: auto;
  height: calc(100vh - 180px);
}

.menu {
  padding-left: 1rem;
}

.sizeBox {
  position: fixed;
  left: 175px;
  top: 195px;
  width: 22px;
  height: 180px;
  z-index: 10;
}

.amplification {
  font-size: 20px;
  color: rgb(57, 132, 194);
  position: absolute;
  top: -28px;
  left: 9px;
  cursor: pointer;
}

.narrow {
  font-size: 20px;
  color: rgb(57, 132, 194);
  position: absolute;
  bottom: -55px;
  left: 9px;
  cursor: pointer;
}

.tips {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  margin-right: 5px;
}

.abgc {
  background-color: rgb(229, 224, 236);
}

.bbgc {
  background-color: rgb(221, 217, 195);
}

.cbgc {
  background-color: rgb(201, 224, 220);
}

.zbgc {
  background-color: rgb(250, 232, 201);
}
</style>
